<div class="picture__container"> 
   <div class="img__house">
    <img
    (click)="addPicture()"
    title="click to add a picture"
    class=" circular medium ui image modified-img"
    [src]="fileFromStore ? fileFromStore : '/assets/images/no-product.svg'"
  />
    <span (click)="addPicture()"
     class="add__picture">
      <img style="max-width: 80%;" src="/assets/images/camera.svg" alt="">
     </span>
   </div>
  <input
    (change)="fileToBeCropped($event)"
    type="file"
    id="picture-upload"
    name="img"
    accept="image/*"
    hidden
  />
  <button
    (click)="uploadImage()"
    type="button"
    id="uploadButton"
    class="ui primary button fluid modified-button"
    disabled
  >
    Upload and continue
  </button>
</div>

<!-- <button (click)="lauchModal()" id="btnTrigger" class="btn btn button--no-width">
  launch me
</button> -->

<div
  id="myModal2"
  class="modal"
  style="z-index: 2000;"
  [style.display]="showModal"
>
  <!-- Modal content -->
  
  <div class="modal-content" style="position: relative">
    <button style="display: none" class="modal-close">
      &times;
    </button>

    <div class="cover" 
     *ngIf="imageHasBeenLoadedInCropper == 'no'"
      >
      <app-loader>
  
      </app-loader>
    </div>

    <!-- <button  class="fakeButton inner">
      &times;
    </button> -->

    <div class="modal-body" style="display: 'block'">
      <div>
        <image-cropper
          style="width: 100%; max-height: 500px;"
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="1 / 1"
          [resizeToWidth]="500"
          [resizeToHeight]="500"
          [cropperMinWidth]="510"
          [cropperMinHeight]="510"
          [onlyScaleDown]="true"
          format="jpeg"
          [imageQuality]="92"
          (imageCropped)="imageCropped($event)"
        >
        </image-cropper>
      </div>
      <div class="text-center mt-5 w-100 flex justify-center align-center">
        <button
          (click)="imageCroppingDone()"
          type="button"
          class="btn btn-success modified mr-3"
        >
          Done
        </button>

        <button
          (click)="closeModal()"
          type="button"
          class="btn btn-success modified warning"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
